import { FormArray, FormControl, FormGroup } from '@angular/forms';
import { Guid, Nillable } from '@web/utils';

export type AdminShippingMethodFormControls = {
  name: FormControl<Nillable<string>>;
  category: FormControl<Nillable<string>>;
  description: FormControl<Nillable<string>>;
  prices: FormArray<AdminShippingMethodPriceFormGroup>;
};

export type AdminShippingMethodPriceFormControls = {
  countryId: FormControl<Nillable<Guid>>;
  price: FormControl<Nillable<number>>;
  paymentMethodIds: FormControl<Nillable<Guid[]>>;
};

export class AdminShippingMethodPriceFormData {
  public constructor(
    private readonly data: {
      countryId: Guid;
      price: number;
      paymentMethodIds: Guid[];
    },
  ) {}

  public get countryId(): Guid {
    return this.data.countryId;
  }

  public get price(): number {
    return this.data.price;
  }

  public get paymentMethodIds(): Guid[] {
    return this.data.paymentMethodIds;
  }
}

export class AdminShippingMethodFormData {
  public static NameMaxLength = 255;
  public static CategoryMaxLength = 255;
  public static DescriptionMaxLength = 10000;

  public constructor(
    private readonly data: {
      name: string;
      category: string;
      description: string;
      prices: AdminShippingMethodPriceFormData[];
    },
  ) {}

  public get name(): string {
    return this.data.name;
  }

  public get category(): string {
    return this.data.category;
  }

  public get description(): string {
    return this.data.description;
  }

  public get prices(): AdminShippingMethodPriceFormData[] {
    return this.data.prices;
  }
}

/* prettier-ignore */
export type AdminShippingMethodFormGroup = FormGroup<AdminShippingMethodFormControls>;

/* prettier-ignore */
export type AdminShippingMethodPriceFormGroup = FormGroup<AdminShippingMethodPriceFormControls>;
